module.exports = {
      id: "water--marker-usage",
      viewBox: "0 0 385 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#water--marker-usage",
      toString: function () {
        return this.url;
      }
    }